import { Injectable } from '@angular/core';
import { tap, mapTo } from 'rxjs/operators';
import { FantasyHistoryStore } from './fantasy-history.store';
import { ApiService } from '../../shared/services/core/api.service';
import { FantasyHistory } from './models/fantasy-history.model';

@Injectable({ providedIn: 'root' })
export class FantasyHistoryService {
  constructor(private fantasyHistoryStore: FantasyHistoryStore, private api: ApiService) {}

  /**
   * Calls the API to fetch fantasy games history and sets the store
   * @param take number of items to select
   */
  fetchFantasyHistory(take: number = 8) {
    return this.api.get<FantasyHistory>('fantasy/history?take=' + take).pipe(
      tap(history => this.fantasyHistoryStore.set(history)),
      mapTo(null)
    );
  }
}
